export const environment = {
  // WWUBaseUrl: 'https://japembzd8m.us-east-1.awsapprunner.com/api',
  // apiBaseUrl: 'https://user-dev-be.tsin.ca/api',
  WWUBaseUrl: 'https://ukammvdjzt.us-east-1.awsapprunner.com/api',
  apiBaseUrl: 'https://ctg3k2hutn.us-east-1.awsapprunner.com/api',
  authBaseUrl: 'https://ctg3k2hutn.us-east-1.awsapprunner.com/api',
  proBaseUrl: 'https://pro-be.tsin.ca/api',
  authUrl: 'https://portal1.tsin.ca',
  paymentServiceUrl: 'https://tsinpayment.tsin.ca',
  production: true,
  salt: 'ZC\f?.Kp[jnhXf3-"<f3{/tZS@#~(8on',
  proServiceUrl: "https://pro.tsin.ca",
  proServiceTestUrl: "https://d24t9hvbz0aqv1.cloudfront.net", //Pro Test environment
  learningServiceUrl: "https://learn.tsin.ca",
  learningServiceTestUrl: "https://d2heizu3e84fzd.cloudfront.net", // Learning Test environment
  workwithusServiceUrl: "https://work-with-us.tsin.ca",
  recaptchaSiteKey: '6LeGUecqAAAAAG7TT48TUcRNZTvZn7bTlZC9W5FP',
  examServiceUrl: "https://exam.tsin.ca",
};
